// extracted by mini-css-extract-plugin
export default {"tic_tac_container":"tic-tac-toe-game_tic_tac_container__YBwV+"};